// @flow
import styled from "styled-components";
import colors from '../../assets/css/colors';
import { below } from '../../assets/css/media';

export const UserName = styled.h5`
	font-size: 12px;
	color: ${colors.darkGrey};
	${below.phone`
		font-size: 10px;
	`}
`;

export default UserName;


// WEBPACK FOOTER //
// ./src/components/PlayersTable/userName.js